import { render, staticRenderFns } from "./OAuthCallbackView.vue?vue&type=template&id=18c9d91a&scoped=true&"
import script from "./OAuthCallbackView.vue?vue&type=script&lang=js&"
export * from "./OAuthCallbackView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c9d91a",
  null
  
)

export default component.exports